import {useState, useEffect} from 'react';
import Header from '../../../components/header';
import * as Yup from 'yup';
import {Form, Formik} from 'formik';
import FormikSelect from '../../../components/formikFileds/select';
import {
  CitiesToOption,
  ProvincesToOption,
} from '../../../utilities/helper/provincesToOption';
import CustomButton from '../../../components/customButton';
import UseGetProvince from '../../../utilities/hooks/province/useGetProvince';
import FormikInput from '../../../components/formikFileds/input';
import UploadImage from '../../../module/profile/uploadImage';
import {IUploadImage} from '../../../models/utilities/uploadImage';
import {useAuth} from '../../../context/authContext';

import useEditProfile from '../hooks/useEditProfile';
import useGetProfile from '../hooks/useGetProfile';
import {account_types} from '../../post/utility/__data';

interface IEditProfile {
  name: string;
  state: string;
  city: string;
  account_type: string;
}

const AddSchema = Yup.object().shape({
  name: Yup.string().required('نام  اجباری می باشد'),
  state: Yup.string().required('استان اجباری می باشد'),
  city: Yup.string(),
  account_type: Yup.string().required('نقش کاربری اجباری می باشد'),
});

const EditProfile = () => {
  const {supplierProfile} = useAuth();
  const initialValues: IEditProfile = {
    name: supplierProfile?.name || '',
    city: supplierProfile?.city.toString() || '',
    state: supplierProfile?.state.toString() || '',
    account_type: supplierProfile?.account_type || '',
  };
  const {provinces} = UseGetProvince();
  const {editProfile, isLoading, isSuccess} = useEditProfile();
  const {refetch} = useGetProfile(supplierProfile?.guid || '');
  const [image, setImage] = useState<Array<IUploadImage>>([]);

  useEffect(() => {
    if (isSuccess) {
      refetch();
    }
  }, [isSuccess, refetch]);
  return (
    <>
      <Header title="پروفایل" />
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={AddSchema}
          onSubmit={values => {
            const payload: IUpdateProfilePayload = {
              account_type: values?.account_type,
              city: values.city,
              state: values.state,
              guid: supplierProfile?.guid || '',
              name: values?.name,
              ...(image[0] && {profile_image: image[0]?.file}),
            };
            editProfile(payload);
          }}
        >
          {({values}) => (
            <Form noValidate>
              <div className="px-4">
                <div className="mt-3">
                  <UploadImage images={image} setImages={setImage} />
                </div>
                <div className="mt-4">
                  <FormikInput
                    name="name"
                    label="نام و  نام خانوادگی"
                    required
                  />
                </div>
                <div className="mt-4">
                  <FormikSelect
                    name="state"
                    label="استان"
                    Options={ProvincesToOption(provinces || [])}
                    required
                  />
                </div>
                <div className="mt-4">
                  <FormikSelect
                    name="city"
                    label="شهر"
                    Options={CitiesToOption(
                      provinces?.find(x => x.id === Number(values.state))
                        ?.cities || [],
                    )}
                    disabled={!values.state}
                  />
                </div>
                <div className="mt-4">
                  <FormikSelect
                    name="account_type"
                    label="نقش کاربری"
                    Options={account_types}
                    required
                  />
                </div>
                <div className="mt-4">
                  <CustomButton
                    type="submit"
                    title="ذخیره"
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default EditProfile;
